import * as React from 'react';
import { inject, observer } from 'mobx-react';
import OrderHistoryList from '../../components/OrderHistoryList';
import Spinner from '../../components/Spinner';
import { ORDER_HISTORY_STORE } from '../../constants/constants';

@inject(
  ORDER_HISTORY_STORE
)
@observer
class OrderHistory extends React.Component {

  componentDidMount() {
    this.props[ORDER_HISTORY_STORE].fetchOrders();
  }

  render() {
    const orders = this.props[ORDER_HISTORY_STORE].orderList;
    const loadingOrders = this.props[ORDER_HISTORY_STORE].requesting;
    return(
      <div className="section section--order-history">
        <OrderHistoryList orders={orders}/>
        {loadingOrders ? <Spinner /> : null}
      </div>
    );
  }
}

export default OrderHistory;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/order-history/OrderHistory.tsx